<template>
    <div class="border border-solid border-black text-center p-5 pb-8 md:m-4 bg-white">
        <h2 v-text="$t('DELIVERIES_SUMMARY_TITLE')"/>
        <div class="my-4">
            <div class="m-2">
                <p v-if="selectedPlan" v-html="$t('DELIVERIES_SUMMARY_SHORT', {
                    deliveries: totalDeliveries,
                    frequency: frequency})"/>
                <p v-else v-text="$t('DELIVERIES_SUMMARY_YOU_TELL')"></p>
            </div>

            <div v-show="selectedPlan" class="flex items-center w-10/12 md:w-3/5 mx-auto my-6">
                <div class="w-1/6 md:w-2/6 flex items-center justify-center">
                    <img class="h-24" src="@/assets/images/pages/account/gifting/vase-small.svg" alt="vase">
                </div>
                <div class="w-5/6 md:w-4/6 pl-1">
                    <p v-html="$t('DELIVERIES_SUMMARY_VASE_COPY')"/>
                </div>
            </div>

            <div v-show="selectedPlan" class="m-2">
                <p v-html="$t('DELIVERIES_SUMMARY_FULL', {
                    deliveries: totalDeliveries,
                    price: multipleDeliveriesPrice,
                    totalPrice: totalPrice})"/>
                <p v-if="coupon && validDiscount" v-html="$t('DELIVERIES_SUMMARY_DISCOUNTED', {discountedPrice: discountedPrice})"/>
            </div>
        </div>

        <div class="sm:px-20 md:px-0 lg:px-16 xl:px-32">
            <button class="btn btn--primary btn--full-width text-xs"
                    @click="submit"
                    v-html="$t('DELIVERIES_SUMMARY_NEXT')">
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PLAN_FORTNIGHTLY, PLAN_MONTHLY, PLAN_WEEKLY, SECTION_NUMBER_OF_DELIVERIES } from '@/constants/Gifting';

export default {
    name: 'DeliveriesSummary',
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_NUMBER_OF_DELIVERIES);
            this.$router.push({ name: 'account.gifting.delivery-address' });
        },
        calculateDiscountAmount() {
            const discountType = this.coupon.discountType;
            const discountValue = this.coupon.discount;
            if (discountType === 'percentage') {
                const saving = this.totalPrice * (discountValue / 100);
                return saving;
            } else if (discountType === 'amount') {
                const saving = discountValue * 0.01;
                return saving;
            }
            return 0;
        },
    },
    mounted() {
        this.$store.dispatch('gifting/fetchPrices');
        this.$store.dispatch('gifting/fetchGiftingCoupons');
    },
    computed: {
        ...mapGetters({
            selectedPlan: 'gifting/getFrequencyForSubscription',
            totalDeliveries: 'gifting/getNumberOfDeliveriesForSubscription',
            weeklyPrice: 'gifting/getPricePerSubscriptionDelivery',
            totalPrice: 'gifting/getTotalPriceForDeliveries',
            coupon: 'gifting/getMultiGiftCoupon',
        }),
        frequency() {
            switch (this.selectedPlan) {
            case PLAN_WEEKLY:
                return this.$t('FREQUENCY_SELECTION_WEEKLY_NOUN');
            case PLAN_FORTNIGHTLY:
                return this.$t('FREQUENCY_SELECTION_FORTNIGHTLY_NOUN');
            case PLAN_MONTHLY:
                return this.$t('FREQUENCY_SELECTION_MONTHLY_NOUN');
            }
        },
        multipleDeliveriesPrice() {
            return parseInt(this.weeklyPrice || 0);
        },
        discountedPrice() {
            const saving = this.calculateDiscountAmount();
            const price = this.totalPrice - saving;
            return price.toFixed(2);
        },
        validDiscount() {
            const minBoxes = this.coupon.minimumWeeks;
            return this.totalDeliveries >= minBoxes;
        },
    },
};
</script>
